import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import { useParams } from 'react-router-dom';
import ModuleSettingsExpedition from '@components/features/module-settings/expedition/ModuleSettingsExpedition.tsx';

interface ComponentProps {}

const ModuleSettingsExpeditionPage: React.FC<ComponentProps> = () => {
  const { companyId } = useParams();

  if (!companyId) {
    return <></>;
  }

  return (
    <>
      <AdminLayout title={'Expedition module settings'}>
        <ModuleSettingsExpedition companyId={companyId} />
      </AdminLayout>
    </>
  );
};

export default withAuthenticationRequired(ModuleSettingsExpeditionPage);
